import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCompletionStatus, CompletionStatusResponse } from '@/api/company-profile.api';

export const COMPLETION_STATUS_QUERY_KEY = 'completion-status';

export const useCompletionStatus = (tenantId: number | undefined) => {
  return useQuery({
    queryKey: [COMPLETION_STATUS_QUERY_KEY, tenantId],
    queryFn: async (): Promise<CompletionStatusResponse> => {
      if (!tenantId) {
        throw new Error('Tenant ID is required');
      }
      return await getCompletionStatus(tenantId);
    },
    enabled: !!tenantId,
    staleTime: 0, // Always consider data stale
    refetchOnWindowFocus: true,
    retry: 2,
  });
};

// Helper to manually refetch completion status - call this after mutations
export const useRefetchCompletionStatus = () => {
  const queryClient = useQueryClient();

  return async () => {
    await Promise.all([
      queryClient.refetchQueries({ queryKey: [COMPLETION_STATUS_QUERY_KEY] }),
      queryClient.refetchQueries({ queryKey: ['step-progress'] }),
    ]);
  };
};
